import { render, staticRenderFns } from "./m-documents-table-selectable.vue?vue&type=template&id=1dce9979&scoped=true&lang=pug"
import script from "./m-documents-table-selectable.vue?vue&type=script&lang=js"
export * from "./m-documents-table-selectable.vue?vue&type=script&lang=js"
import style0 from "./m-documents-table-selectable.vue?vue&type=style&index=0&id=1dce9979&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dce9979",
  null
  
)

export default component.exports